var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkDesk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.857 13.714h4.286a.429.429 0 00.428-.428V3.429A.429.429 0 007.143 3H2.857a.429.429 0 00-.428.429v9.857c0 .236.191.428.428.428zm.429-.857V12h3.428v.857H3.286zm3.428-9v7.286H3.286V3.857h3.428zM9.286 12h5.143v.857h-1.715a.429.429 0 000 .857H17a.429.429 0 100-.857h-1.714V12h5.143a.429.429 0 00.428-.429V4.714a.429.429 0 00-.428-.428H9.286a.429.429 0 00-.429.428v6.857c0 .237.192.429.429.429zm.428-6.857H20v6H9.714v-6zM4.143 8.57a.857.857 0 111.714 0 .857.857 0 01-1.714 0zM22.57 15.64v4.932a.429.429 0 01-.857 0V15.64a.639.639 0 00-.638-.639H3.504a.639.639 0 00-.647.639v4.932a.429.429 0 01-.857 0V15.64c0-.826.67-1.496 1.496-1.496h17.571a1.496 1.496 0 011.504 1.496zm-14.142.218v4.714a.429.429 0 01-.858 0v-4.714a.429.429 0 11.858 0zm-1.286 1.714a.429.429 0 01-.429.429h-3a.429.429 0 010-.857h3c.237 0 .429.192.429.428z",
    stroke: "#FFF",
    strokeWidth: 0.1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4h12v8H9z"
  })))));
}
export default SvgWorkDesk;